import React, { useState } from "react";
import { Input } from "antd";
import { Base_Uri } from "../../../Constant/BaseUri";

const ProductSearch = ({ products, setSelectProductFromSearch }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [isDropdownVisible, setDropdownVisible] = useState(false);

  const handleSearchProducts =async (value) => {
    const searchValue = value.trim().toLowerCase();
    if (!searchValue) {
      setSearchResults([]);
      setDropdownVisible(false); // Hide the dropdown if no input
      return;
    }

    // Tokenize search input
    // const searchTokens = searchValue.split(" ");
    const useExtendedSearch = searchValue.length > 3; // Only use barcode/sku if length > 3
          //console.log(useExtendedSearch, "useExtendedSearch");
          if (!useExtendedSearch) return
          let dataToken = await sessionStorage.getItem("userData");
          dataToken = JSON.parse(dataToken);
          let token = dataToken;
          const response = await fetch(
            `${Base_Uri}getProducts?search=${encodeURIComponent(
              searchValue
            )}&useExtendedSearch=${useExtendedSearch}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );

          const filteredProducts = await response.json()
          //console.log(filteredProducts,"filteredProducts")
    // Build filtered products
    // const filteredProducts = products.filter((item) =>
    //   searchTokens.every((token) =>
    //     [item.productName, item.color, item.sku, item.barcode?.toString()]
    //       .filter(Boolean) // Filter out undefined/null values
    //       .some((field) => field.toLowerCase().includes(token))
    //   )
    // );

    // Update search results
    setSearchResults(filteredProducts?.data);
    setDropdownVisible(filteredProducts?.data?.length > 0); // Show dropdown if results exist
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {/* Search Input */}
      <Input
        placeholder="Search products"
        onChange={(e) => handleSearchProducts(e.target.value)}
        style={{ width: "100%", height: "100%" }}
      />

      {/* Results Container */}
      {isDropdownVisible && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            maxHeight: "200px",
            overflowY: "auto",
            background: "white",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
            zIndex: 1000,
            marginTop: 10,
          }}
        >
          {searchResults.length > 0 ? (
            searchResults.map((product) => (
              <div
                key={product.id}
                style={{
                  padding: "8px 12px",
                  cursor: "pointer",
                  borderBottom: "1px solid #f0f0f0",
                  textAlign: "left",
                }}
                onClick={() => {
                    setSelectProductFromSearch({})
                  setSelectProductFromSearch(product);
                  setDropdownVisible(false);
                }}
              >
                {product.productName}
              </div>
            ))
          ) : (
            <div style={{ padding: "8px 12px", color: "#999" }}>
              No results found.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProductSearch;
